import { BaseInputProps, buildTextInputTestIds, TextInput, TextInputTestIds } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { integerRegex } from "../../helpers/validationHelper";

export const buildIntegerInputTestIds = buildTextInputTestIds;
export type IntegerInputTestIds = TextInputTestIds;

export interface IntegerInputProps extends BaseInputProps {
  testId?: string;
  label?: string;
  min?: number;
  max?: number;
  onChange?: (value:number) => void;
  validator?: (value:number) => string[] | undefined;
  defaultValue?: number;
  loading?: boolean;
  className?: string;
}

export const IntegerInput = (
  { testId, label, min, max, onChange, validator, defaultValue, loading, required, ...rest }: IntegerInputProps,
): JSX.Element => {
  const internalValidation = (value:string): string[] | undefined => {
    const errors: string[] = [];
    // eslint-disable-next-line max-len
    if ((!value && required) || (value && !integerRegex.test(value))) errors.push(Messages.validation.validIntegerNumber());

    const numValue = Number(value === "" ? undefined : value);
    const minValue = Number(min);
    const maxValue = Number(max);
    if (Number.isInteger(minValue) && !Number.isInteger(maxValue)) {
      // eslint-disable-next-line max-len
      if (!Number.isInteger(numValue) || numValue < minValue) errors.push(Messages.validation.integerMin(minValue.toString()));
    }
    if (!Number.isInteger(minValue) && Number.isInteger(maxValue)) {
      // eslint-disable-next-line max-len
      if (!Number.isInteger(numValue) || numValue > maxValue) errors.push(Messages.validation.integerMax(maxValue.toString()));
    }
    if (Number.isInteger(minValue) && Number.isInteger(maxValue)) {
      if (!Number.isInteger(numValue) || numValue < minValue || numValue > maxValue) {
        errors.push(Messages.validation.integerRange(
          minValue.toString(),
          maxValue.toString(),
        ));
      }
    }
    if (validator) {
      const externalValidatorErrors = validator(numValue);
      if (externalValidatorErrors !== undefined && externalValidatorErrors.length > 0) {
        externalValidatorErrors.forEach(error => errors.push(error));
      }
    }
    return errors.length > 0 ? errors : [];
  };

  const internalOnChange = (newValue:string): void => {
    const numValue = Number(newValue);
    onChange?.(numValue);
  };

  return (
    <TextInput
      {...rest}
      testId={testId}
      label={label}
      onChange={internalOnChange}
      validator={internalValidation}
      // We are making sure that the default value is not null or undefined
      // All other values will have validation triggerred on them
      // The 2 scenarios we are handling would result in the application crashing
      // eslint-disable-next-line eqeqeq
      defaultValue={defaultValue != undefined ? defaultValue.toString() : undefined}
      loading={loading}
      required={required}
    />
  );
};
